import vessels from './data/vessels.json'
import fleetTypes from './fleet-types.vue'

export default {
  components: {
    fleetTypes
  },
  props: {
    vessels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      selectedVesselType: '',
    }
  },
  computed: {
    filteredVessels: function () {
      var filteredVessels = [];
      if (this.selectedVesselType) {
        this.vessels.filter((vessel) => {
          if (vessel.type === this.selectedVesselType) {
            filteredVessels.push(vessel)
          }
        });
        return filteredVessels;
      } else {
        return this.vessels;
      }
    },
  },
  methods: {
    changeVesselType(vesselType) {
      if (vesselType) {
        this.selectedVesselType = vesselType;
      } else {
        this.selectedVesselType = '';
      }
    },
  }
}